import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../language/vn';
import {CommandUtil} from '../../../global/commandutil';
import {environment} from '../../../../environments/environment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CalendarNewsComment} from '../../../models/calendar/calendarnewscomment';
import {CalendarNewsCommentService} from '../../../service/calendar/service-calendarnewscomment';
import {Sessioncommand} from '../../../global/sessioncommand';
import {LogView} from '../../../models/log/logview';
import {LogViewService} from '../../../service/log/service-logview';
import {MeetingXuLy} from '../../../models/info/meetingxuly';
import {CalendarNewStaffs} from '../../../models/calendar/calendarnewstaffs';
import {CalendarRead} from '../../../models/calendar/calendarread';
import {CalendarReadService} from '../../../service/calendar/service-calendarread';
@Component({
  templateUrl: './tonghop.component.html',
  encapsulation: ViewEncapsulation.None

})
export class TongHopLichCongTacComponent implements OnInit, AfterViewInit {
  public language = language;
  public weekId: number = 0;
  public yearId: number = 0;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public  onClose: Subject<boolean>;
  public calendarNewsCommentLists: CalendarNewsComment[] = [];
  public calendarReadList: CalendarRead[] = [];
  public logViewList: LogView[] = [];
  private dataComment: Object[] = [];
  constructor(
    public calendarNewsCommentService: CalendarNewsCommentService ,
    public calendarReadService: CalendarReadService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public logViewService: LogViewService
  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();

  }


  public edit(weekId: number, yearId: number) {
    this.weekId = weekId;
    this.yearId = yearId;
    this.load();

  }

  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public load()
  {
    this.calendarNewsCommentService.getCountByKeyword(this.weekId, this.yearId).subscribe( data => this.totalItems = data);
      this.calendarNewsCommentService.findAllByPaging(this.weekId, this.yearId, this.currentPage, this.maxSize).subscribe( data => {
        this.calendarNewsCommentLists = data;
      });


  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.load();
  }

}

